import React from 'react';
import classnames from 'classnames';

import styles from './backgrounder.scss';

const Backgrounder = ({ children, className }) => (
  <div className={classnames(styles.backgrounder, className)}>{children}</div>
);

export default Backgrounder;
